import { Row, RenderConfig, TextInput, SelectInput } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	userId: 'userId',
	bucket: 'bucket'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.userId]: new RenderConfig()
		.setName('userId')
		.setLabel('Zupee User Id or Device Id')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.bucket]: new RenderConfig()
		.setName('bucket')
		.setLabel('Bucket')
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: false, edit: true }, required: true })
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.userId), new Row(FORM_FIELD_KEYS.bucket)];
